import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useSidebar } from '@/context/SidebarContext';
import SearchBar from '@/components/search/SearchBar';
import styles from './Header.module.css';

export default function Header() {
  const { user, isAdmin, signOut } = useAuth();
  const { toggle, isMobile } = useSidebar();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        {isMobile && (
          <button className={styles.menuButton} onClick={toggle} aria-label="Toggle menu">
            <span />
            <span />
            <span />
          </button>
        )}
        <Link to="/app" className={styles.logo}>
          <img src="/logo.png" alt="GitDish" className={styles.logoImage} />
        </Link>
      </div>

      <div className={styles.center}>
        <SearchBar />
      </div>

      <div className={styles.right}>
        <div className={styles.userMenu}>
          <button
            className={styles.userButton}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <span className={styles.username}>{user?.username}</span>
            <span className={styles.chevron}>▼</span>
          </button>

          {isDropdownOpen && (
            <>
              <div className={styles.dropdownBackdrop} onClick={() => setIsDropdownOpen(false)} />
              <div className={styles.dropdown}>
                <Link
                  to="/app/settings"
                  className={styles.dropdownItem}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Settings
                </Link>
                {isAdmin && (
                  <Link
                    to="/admin"
                    className={styles.dropdownItem}
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    Admin
                  </Link>
                )}
                <button className={styles.dropdownItem} onClick={handleSignOut}>
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
